declare var swal: any;
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ActorCertificationRequest, ActorCertificationsInfoController, VitalItemHistoryByFormattedCodeRequest, VitalItemHistoryByFormattedCodeController, VitalLatestFormByFormattedCodeRequest, VitalLatestFormByFormattedCodeController, SaveVitalItemRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';

import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { NgbCertificationsinfoModal } from '../certificationsinfo/modals/certificationinfo.modal';
import { NgbActorDocsModal } from '../modals/actordocs/actordocs.modal';
import { CustomDateTimeService } from '../../../../services/datetime.service';


import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

@Component({
  selector: 'vitals',
  templateUrl: './vitals.component.html'

})

export class VitalsInfoComponent implements OnInit {
  @Input() ActorCode: number;
  @Input() ActorType: number;
  @Input() FormattedCode: string;
  @Input() CanEdit: number;
  @Input() CanShow: number;

  CurrentActorCertificationRequest: ActorCertificationRequest;

  CurrentActorCertificationsInfoController: ActorCertificationsInfoController[];

  //
  CurrentActorEditCertificationRequest: ActorCertificationRequest;
  CurrentEditVitalRequest: SaveVitalItemRequest;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public ShowVitalDetail: boolean = false;
  public EditVitalDetail: boolean = false;
  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();
  public IssueMaxDateV = new Date();
  public AttributeName: string;


  ValidTo: NgbDateStruct;
  ValidFrom: NgbDateStruct;
  UpdateDate: NgbDateStruct;

  //UpdateDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  IssuemaxDate: NgbDateStruct;
  //CurrentVitalItemHistoryByFormattedCodeRequest: VitalItemHistoryByFormattedCodeRequest;
  //CurrentVitalItemHistoryByFormattedCodeController: VitalItemHistoryByFormattedCodeController[];
  //LoadPatients() {
  //  this.CurrentVitalItemHistoryByFormattedCodeRequest = new VitalItemHistoryByFormattedCodeRequest();



  //  this.CurrentVitalItemHistoryByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.GetVitalItemHistoryByFormattedCodeController();
  //}

  //GetVitalItemHistoryByFormattedCodeController() {
  //  this.StartRefreshing();

  //  this.CurrentVitalItemHistoryByFormattedCodeRequest.FormattedCode = this.FormattedCode;
  //  this.CurrentVitalItemHistoryByFormattedCodeRequest.VitalItemType = "";

  //  this.actorservice.GetVitalItemHistoryByFormattedCodeController(this.CurrentVitalItemHistoryByFormattedCodeRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {
  //        //this.CurrentVitalItemHistoryByFormattedCodeRequest.FormattedCode = this.FormattedCode;
  //        this.CurrentVitalItemHistoryByFormattedCodeController = this.ApiResData.Result;
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );
  //}
  CurrentVitalLatestFormByFormattedCodeController: VitalLatestFormByFormattedCodeController[];
  CurrentVitalLatestFormByFormattedCodeRequest: VitalLatestFormByFormattedCodeRequest;
  LoadPatients() {
    this.CurrentVitalLatestFormByFormattedCodeRequest = new VitalLatestFormByFormattedCodeRequest();
    this.CurrentVitalLatestFormByFormattedCodeRequest.FormattedCode = this.FormattedCode;
    this.CurrentVitalLatestFormByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetVitalLatestFormByFormattedCodeController();
  }

  GetVitalLatestFormByFormattedCodeController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetVitalLatestFormByFormattedCodeController(this.CurrentVitalLatestFormByFormattedCodeRequest)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentVitalLatestFormByFormattedCodeController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService, private actorservice: ActorService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) { }


  ngOnInit() {
    this.LoadPatients();

    this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);
    this.MaxDateV.setFullYear(this.MaxDateV.getFullYear() + 80);
    this.maxDate = { year: this.MaxDateV.getFullYear(), month: this.MaxDateV.getMonth() + 1, day: this.MaxDateV.getDate() };
    this.minDate = { year: this.MinDateV.getFullYear(), month: this.MinDateV.getMonth() + 1, day: this.MinDateV.getDate() };
    this.IssuemaxDate = { year: this.IssueMaxDateV.getFullYear(), month: this.IssueMaxDateV.getMonth() + 1, day: this.IssueMaxDateV.getDate() };

    this.CanAdjustgetTimezoneOffset = AppData.CanAdjustgetTimezoneOffset;

    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorCertificationRequest = new ActorCertificationRequest();
    this.CurrentActorCertificationsInfoController = new Array<ActorCertificationsInfoController>();
    this.CurrentActorCertificationRequest.ActorCode = this.ActorCode;

    this.CurrentActorCertificationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentActorEditCertificationRequest = new ActorCertificationRequest();
    this.CurrentActorEditCertificationRequest.ActorCode = this.ActorCode;

    this.CurrentActorEditCertificationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentEditVitalRequest = new SaveVitalItemRequest();
    this.CurrentEditVitalRequest.FormattedCode = this.FormattedCode;

    this.CurrentEditVitalRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    if (this.CanShow === 1) {
      this.GetActorCertificationsInfoController();
    }

  }
  clearData2() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorCertificationRequest = null;
    this.CurrentActorCertificationRequest = new ActorCertificationRequest();
    this.CurrentActorEditCertificationRequest.ConditionalOperator = 1;
    this.CurrentActorCertificationRequest.ActorCode = this.ActorCode;
    this.CurrentActorCertificationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;



  }
  clearData() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorCertificationRequest = null;
    this.CurrentActorCertificationRequest = new ActorCertificationRequest();
    this.CurrentActorEditCertificationRequest.ConditionalOperator = 1;
    this.CurrentActorCertificationRequest.ActorCode = this.ActorCode;
    this.CurrentActorCertificationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowList = false;


  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  public onInputValidFrom(value: Date): void {

    this.CurrentActorEditCertificationRequest.ValidFrom = value;
  }
  public onInputValidTo(value: Date): void {

    this.CurrentActorEditCertificationRequest.ValidTo = value;
  }
  onCredentialTypeByGroup(event: any) {

    if (event != null) {

      this.CurrentActorCertificationRequest.CredentialType = event;


    }


  }
  onCredentialTypeEditByGroup(event: any) {

    if (event != null) {

      this.CurrentActorEditCertificationRequest.CredentialType = event;


    }


  }

  GetActorCertificationsInfoController() {
    this.StartRefreshing();
    this.hcpservice.GetActorCertificationsInfoController(this.CurrentActorCertificationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentActorCertificationsInfoController = this.ApiResData.Result;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  onSubmit() {

    this.CurrentEditVitalRequest.ConditionalOperator = 20;

    //this.CurrentEditVitalRequest.UpdateDate = new Date(this.parserFormatter.format(this.UpdateDate));
    //this.CurrentSaveVitalItemRequest.ValueData = this.ValueaData;
    this.CurrentEditVitalRequest.Remarks = "";
    this.CurrentEditVitalRequest.SectionTemplate = this.SelectedVitalDetails.SectionTemplate;
    //this.CurrentSaveVitalItemRequest.ValueData = "";
    this.CurrentEditVitalRequest.VitalItemType = this.SelectedVitalDetails.AttributeName;
    //this.CurrentEditVitalRequest.UpdateDate = this.ScheduleDate;
    this.CurrentEditVitalRequest.UpdateDate = new Date(this.parserFormatter.format(this.UpdateDate));
    this.actorservice.SaveVitalItemData(this.CurrentEditVitalRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.ShowVitalDetail = true;
            this.EditVitalDetail = false;
            this.LoadPatients();
            this.ShowList = true;
            this.clearData2();
            this.LoadVitals();




            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  ShowList: boolean = true;
  CancelUpdateOperation() {
    //alert("cancell upd op");
    this.ShowList = true;
  }
  CancelNewOperation() {
    //alert("cancell new op");
    this.ShowList = true;
  }

  edit_(EditCurrentActorCertificationsInfoController: ActorCertificationsInfoController) {
    this.ShowList = false;
    this.IsExpand = true;
    this.CurrentActorEditCertificationRequest.ConditionalOperator = 2;
    this.CurrentActorEditCertificationRequest.ActorCredentialCode = EditCurrentActorCertificationsInfoController.ActorCredentialCode;
    this.CurrentActorEditCertificationRequest.ActorCode = EditCurrentActorCertificationsInfoController.ActorCode;

    // alert(EditCurrentActorCertificationsInfoController.CredentialTypeCode);


    this.CurrentActorEditCertificationRequest.CredentialTypeCode = EditCurrentActorCertificationsInfoController.CredentialTypeCode;
    this.CurrentActorEditCertificationRequest.CredentialType = EditCurrentActorCertificationsInfoController.CredentialType;
    this.CurrentActorEditCertificationRequest.CredentialNumber = EditCurrentActorCertificationsInfoController.CredentialNumber;
    this.CurrentActorEditCertificationRequest.ValidFrom = EditCurrentActorCertificationsInfoController.ValidFrom;
    this.CurrentActorEditCertificationRequest.ValidTo = EditCurrentActorCertificationsInfoController.ValidTo;

    if (this.CurrentActorEditCertificationRequest.ValidFrom != null) {
      var SValidFrom = new Date(this.CurrentActorEditCertificationRequest.ValidFrom);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidFrom = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }


    if (this.CurrentActorEditCertificationRequest.ValidTo != null) {
      var SValidTo = new Date(this.CurrentActorEditCertificationRequest.ValidTo);
      if (SValidTo.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidTo = {

          year: SValidTo.getFullYear(),
          month: SValidTo.getMonth() + 1,
          day: SValidTo.getDate()
        }
      }
    }

    this.CurrentActorEditCertificationRequest.IssuingAuthority = EditCurrentActorCertificationsInfoController.IssuingAuthority;
    this.CurrentActorEditCertificationRequest.AdditionalDetails = EditCurrentActorCertificationsInfoController.AdditionalDetail;
    this.CurrentActorEditCertificationRequest.Remarks = EditCurrentActorCertificationsInfoController.Remarks;

    this.isNew = false;
    this.isEdit = true;


  }
  onEditSubmit() {
    if (this.ShowList)
      return;
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEditCertificationRequest.ConditionalOperator = 2;
    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  this.CurrentActorEditCertificationRequest.ValidFrom = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditCertificationRequest.ValidFrom);
    //  this.CurrentActorEditCertificationRequest.ValidTo = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditCertificationRequest.ValidTo);
    //}

    if (this.ValidFrom != null) {



      this.CurrentActorEditCertificationRequest.ValidFrom = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorEditCertificationRequest.ValidTo = new Date(this.parserFormatter.format(this.ValidTo));;
    }

    this.hcpservice.SaveActorCertifications(this.CurrentActorEditCertificationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorCertificationsInfoController();
            //alertFunctions.AlertParam('Update Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Updated Successfully.....!');
            this.ShowList = true;
            this.clearData2();




            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }




  del_(ActorCredentialCode: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(ActorCredentialCode);
      // alertFunctions.AlertParam('Deleted Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentities(ActorCredentialCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorCertificationRequest.ConditionalOperator = 3;
    this.CurrentActorCertificationRequest.ActorCredentialCode = ActorCredentialCode;
    this.hcpservice.SaveActorCertifications(this.CurrentActorCertificationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            this.clearData2();
            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            this.ShowList = true;




            this.stopRefreshing();
            this.GetActorCertificationsInfoController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  SelectedVitalDetails: VitalLatestFormByFormattedCodeController;
  VitalDetail(obj: any) {
    var Vital: VitalLatestFormByFormattedCodeController = obj;
    if (Vital != null) {
      this.ShowVitalDetail = true;
      this.EditVitalDetail = false;
      this.SelectedVitalDetails = Vital;
      this.LoadVitals();

    }
    else {
      this.SelectedVitalDetails = null;
      this.ShowVitalDetail = false;
    }

  }
  SelectedVitalDetailsData: VitalItemHistoryByFormattedCodeController[];
  SelectedVitalDetailRequest: VitalItemHistoryByFormattedCodeRequest;
  LoadVitals() {
    // alert("Vitls");
    this.SelectedVitalDetailRequest = new VitalItemHistoryByFormattedCodeRequest();
    this.SelectedVitalDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.SelectedVitalDetailRequest.FormattedCode = this.FormattedCode;
    this.SelectedVitalDetailRequest.VitalItemType = this.SelectedVitalDetails.AttributeName;
    this.SelectedVitalDetailRequest.ConditionalOperator = 10;
    this.GetVitalItemHistoryByFormattedCodeController();
  }
  GetVitalItemHistoryByFormattedCodeController() {
    this.StartRefreshing();
    this.actorservice.GetVitalItemHistoryByFormattedCodeController(this.SelectedVitalDetailRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          //while (this.SelectedVitalDetailsData.length>0)
          //  this.SelectedVitalDetailsData.splice(0, 1); 

          this.SelectedVitalDetailsData = this.ApiResData.Result;


          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  openDocContent(ActorDocCode: any) {
    if (ActorDocCode > 0) {

      let options: NgbModalOptions = {
        size: 'lg'
      };
      const modalRef = this.modalService.open(NgbActorDocsModal, options)//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.ActorDocCode = ActorDocCode;
      modalRef.componentInstance.CanEdit = this.CanEdit;
      modalRef.componentInstance.CanShow = this.CanShow;
      //modalRef.result.then(x => { this.GetActorIdentitiesController() })
    }
    else {
      alertFunctions.AlertParam('No permission to Upload Doc For this Record...!');
    }
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  EditVitalShow(EditVitalDetails: VitalLatestFormByFormattedCodeController) {


    this.ShowVitalDetail = false;
    this.EditVitalDetail = true;
    this.CurrentEditVitalRequest.ValueData = EditVitalDetails.ValueData;
    this.CurrentEditVitalRequest.UpdateDate = EditVitalDetails.Date;
    //alert(EditVitalDetails.Date);
    //this.CurrentEditVitalRequest.UpdateDate = new Date(this.parserFormatter.format(this.UpdateDate));
    if (this.CurrentEditVitalRequest.UpdateDate != null) {
      var SValidFrom = new Date(this.CurrentEditVitalRequest.UpdateDate);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.UpdateDate = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
  }
  BackVitalDetials() {
    this.ShowVitalDetail = true;
    this.EditVitalDetail = false;
  }
}
